import React from 'react';

export const LayoutBody: React.FC<{children: React.ReactNode}> = ({ children }) => {
  return <section className="flex flex-grow justify-stretch gap-4 px-4 pb-4 overflow-hidden">{children}</section>;
};
